export default __webpack_public_path__ + "static/media/bristol-airport.73e38f32.png";